"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethereumSigner_1 = __importDefault(require("./ethereumSigner"));
class PolygonSigner extends ethereumSigner_1.default {
}
exports.default = PolygonSigner;
//# sourceMappingURL=PolygonSigner.js.map